module.exports = __webpack_public_path__ + "static/media/1.enterprise-service.e223882a.png";